import { navigateInShell } from '../../shell/navigation/rootNavigation';
import { useCustomerOverlayStore } from '../store/useCustomerOverlayStore'
import type { CustomerCollectIntent } from '../store/useCustomerOverlayStore';

type NavigationLike = {
  navigate: (route: string, params?: object) => void;
};

export function openCustomerCollectFromSale(
  navigation: NavigationLike,
  intent: CustomerCollectIntent
): void {
  useCustomerOverlayStore.getState().setCollectIntent(intent);
  navigateInShell(navigation, 'MainTabs', { screen: 'Customers' });
}

/** Cierra el flujo actual y abre Clientes → Agregar cliente. */
export function openCustomerNewCustomer(navigation: NavigationLike): void {
  useCustomerOverlayStore.getState().requestOpenNewCustomer();
  navigateInShell(navigation, 'Customers');
}

/** Cierra el flujo actual y abre Clientes → ficha del cliente. */
export function openCustomerDetail(navigation: NavigationLike, customerId: string): void {
  useCustomerOverlayStore.getState().requestOpenCustomerDetail(customerId);
  navigateInShell(navigation, 'Customers');
}
